import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  box: {
    padding: 0,
    display: 'grid',
  },
  title: {
    ...dFlex('start'),
    gap: 4,
  },
  riskLeveler: {
    justifyContent: 'flex-start !important',
  },
  btnBox: {
    ...dFlex('end'),
    marginLeft: 'auto',
  },
  farm: {
    ...dFlex('start'),
  },
}));

export default useStyles;
